import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MedicalServiceWizardService } from '../../../services/wizard/medical-service/medical-service-wizard';

@Component({
  selector: 'medical-service-operation-component',
  templateUrl: './medical-service-operation.component.html',
  styleUrls: ['./medical-service-operation.component.css']
})
export class MedicalServiceOperationComponent implements OnInit {

  form: FormGroup;

  constructor(private medicalServiceWizardService: MedicalServiceWizardService
    , private formBuilder: FormBuilder) {
    const medicalOrderOperation = this.medicalServiceWizardService.getMedicalOrderOperation();
    this.form = this.formBuilder.group({
      MedicalOrderOperation: [medicalOrderOperation]
    });
  }

  ngOnInit(): void {  }
}
